import { render, staticRenderFns } from "./binditemsTab.vue?vue&type=template&id=cd4503ee&"
import script from "./binditemsTab.vue?vue&type=script&lang=js&"
export * from "./binditemsTab.vue?vue&type=script&lang=js&"
import style0 from "./binditemsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports